/**
 * Check for umlaute and other latin marks
 * 
 * Source: https://stackoverflow.com/a/57754227
 */
export const UMLAUT_REGEXP = /[À-ž\u0370-\u03FF\u0400-\u04FF]/gi

export const hasUmlaut = (string: string) => UMLAUT_REGEXP.test(string);